module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/hotsale-mobile.a5e977e3.png";